
<mat-card>
<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px" class="button-container">
    <button [disabled]="!(userPermissions | async).license.write" (click)="addDevice()" mat-stroked-button color="primary" style="align-self: flex-start;">
      <mat-icon>add</mat-icon> <span> Dodaj urządzenie</span>
    </button>

    <button [disabled]="!(userPermissions | async).license.write" (click)="addLicense()" mat-stroked-button color="primary" style="align-self: flex-start;">
      <mat-icon>add</mat-icon> <span> Dodaj licencję</span>
    </button>
  </div>
    <mat-card>
      <h3>Dane użytkownika</h3>
      <div fxLayout="row" fxLayoutGap="15px">
      <app-detail fxFlex="33" header="Użytkownik"
                  [value]="userObject?.firstName + ' ' + userObject?.lastName">
      </app-detail>
      <app-detail fxFlex="33" header="Numer telefonu" [value]="userObject?.phone"></app-detail>
      <app-detail fxFlex="33" header="Adres email" [value]="userObject?.email"></app-detail>
      </div>
    </mat-card>

  <div fxLayout="row" fxLayoutGap="15px">
    <mat-card fxFlex="50">
      <div fxLayout="column" fxLayoutGap="15px">

        <table mat-table [dataSource]="devices" matSort>
          <ng-container matColumnDef="typeOfDevice">
            <th mat-header-cell *matHeaderCellDef> Rodzaj urządzenia </th>
            <td mat-cell *matCellDef="let element">
              <ng-container>
                <a class="default-link" [routerLink]="['/urzadzenia/szczegoly', element.uuid]">
                  {{ element?.typeOfDevice?.name}}
                </a>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="deviceName">
            <th mat-header-cell *matHeaderCellDef> Nazwa </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.name}}
            </td>
          </ng-container>

          <ng-container matColumnDef="serialNumber">
            <th mat-header-cell *matHeaderCellDef> Numer seryjny </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.serialNumber}}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['typeOfDevice', 'deviceName', 'serialNumber']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['typeOfDevice', 'deviceName', 'serialNumber'];"></tr>
        </table>
      </div>
    </mat-card>

    <mat-card fxFlex="50">
      <div fxLayout="column" fxLayoutGap="15px">

        <table mat-table [dataSource]="licenses" matSort>
          <ng-container matColumnDef="typeOfLicense">
            <th mat-header-cell *matHeaderCellDef> Rodzaj licencji </th>
            <td mat-cell *matCellDef="let element">
              <ng-container>
                <a class="default-link" [routerLink]="['/urzadzenia/licencje/szczegoly', element.uuid]">
                  {{ element?.typeOfLicense?.name}}
                </a>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="licenseNumber">
            <th mat-header-cell *matHeaderCellDef> Numer licencji </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.licenseNumber}}
            </td>
          </ng-container>

          <ng-container matColumnDef="expirationDate">
            <th mat-header-cell *matHeaderCellDef> Data ważności do </th>
            <td mat-cell *matCellDef="let element">
              <a *ngIf="element?.expirationDate">{{element?.expirationDate | date: 'yyyy-MM-dd'}}</a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['typeOfLicense', 'licenseNumber', 'expirationDate']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['typeOfLicense', 'licenseNumber', 'expirationDate'];"></tr>
        </table>
      </div>
    </mat-card>
  </div>
</div>
</mat-card>
